import { render, staticRenderFns } from "./ListShopping.vue?vue&type=template&id=5080a297"
import script from "./ListShopping.vue?vue&type=script&lang=js"
export * from "./ListShopping.vue?vue&type=script&lang=js"
import style0 from "./ListShopping.vue?vue&type=style&index=0&id=5080a297&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports